/**
 * Download a file from a url
 */
export const downloadUrl = (url: string, filename: string) => {
  const link = document.createElement('a');
  link.setAttribute('download', filename);
  link.setAttribute('href', url);
  link.click();
};

export default downloadUrl;
